const SortType = {
    Ascendent: 'asc',
    Descendent: 'desc'
};
export default SortType;